<template>
  <div class="hc-compact-page">
    <!-- Header Alert -->
    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text">Daftar <b>Database</b></div>
      <b-button
        variant="primary"
        @click="$router.push('/databases/add')"
        v-if="btnAccess"
        >Tambah</b-button
      >
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-table
              striped
              hover
              :items="items"
              :fields="fields"
              class="mt-3"
              responsive
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'action' ? '25%' : '' }"
                />
              </template>

              <template #cell(photo)="data">
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    image-container
                  "
                >
                  <div class="image-input-wrapper" style="position: relative">
                    <img class="image" :src="data.item.photo" />
                  </div>
                </div>
              </template>

              <template #cell(is_default)="data">
                <i
                  class="fas fa-check"
                  style="color: green"
                  v-if="data.item.is_default"
                  v-b-tooltip.hover
                  title="Default"
                ></i>
                <i
                  class="fas fa-times text-danger"
                  v-if="!data.item.is_default"
                ></i>
              </template>

              <template #cell(action)="data">
                <b-button
                  v-if="data.item.is_default == 1"
                  size="sm"
                  class="btn-icon btn-light-success mr-1"
                  v-b-tooltip.hover
                  title="Default"
                  ><i class="fas fa-check"></i
                ></b-button>
                <b-button
                  v-if="data.item.is_default == 0"
                  size="sm"
                  class="btn-icon btn-light-danger mr-1"
                  v-b-tooltip.hover
                  title="Non Aktif"
                  @click="setDefault(data.item.id)"
                  ><i class="fas fa-times"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-icon btn-light-success mr-1"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({
                      path: '/databases/edit/' + data.item.id,
                    })
                  "
                  v-if="btnAccess"
                  ><i class="fas fa-edit"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-icon btn-light-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="btnAccess"
                  ><i class="fas fa-trash"></i
                ></b-button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import module from "@/core/modules/CrudModule.js";
import Table from "@/view/components/users/Table.vue";
import moment from "moment";

export default {
  name: "master-users",
  components: {
    Table,
  },
  data() {
    return {
      // filter
      filter: {},
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 1,
      fields: [
        {
          key: "number",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "ip",
          label: "IP",
          sortable: true,
        },
        {
          key: "is_default",
          label: "Default",
          sortable: true,
        },
        {
          key: "action",
          label: "Aksi",
          tdClass: "nowrap",
        },
      ],
      items: [],
      // access
      btnAccess: true,
    };
  },
  methods: {
    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = ``;
      let response = await module.paginate(
        "databases",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }

      this.items = response.data;
    },

    async setDefault(id) {
      let result = await module.setDefaultDatabase(
        `databases/${id}/set-default`
      );
      if (result) {
        this.pagination();
      }
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("databases/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    // access
    checkAccess() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);
      for (let a = 0; a < access_right.length; a++) {
        if (access_right[a] == "9002") {
          this.btnAccess = true;
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Database", route: "/databases/" },
    ]);
    this.pagination();
    this.checkAccess();
  },
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}

.hc-compact-page {
  font-family: "Poppins", "Inter", sans-serif;
}

/* Custom styles aligning to the website theme */
.alert-custom {
  border-radius: 16px !important;
  border: 1px solid rgba(231, 237, 244, 0.92) !important;
  box-shadow: 0 10px 30px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff !important;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  
  .alert-icon {
    background-color: rgba(30, 149, 143, 0.08) !important;
    border-radius: 12px;
    padding: 10px;
    color: #1e958f !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    svg {
      fill: #1e958f !important;
      color: #1e958f !important;
      width: 20px;
      height: 20px;
    }
  }

  .alert-text {
    color: #1e293b;
    font-size: 15px;
    font-weight: 600;
    flex-grow: 1;
  }

  /* Tambah Button */
  .btn-primary {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border: none !important;
    border-radius: 10px !important;
    padding: 8px 20px !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    box-shadow: 0 4px 12px rgba(30, 149, 143, 0.2) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(30, 149, 143, 0.3) !important;
    }
  }
}

/* Card Styling */
.card {
  border-radius: 18px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 12px 36px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff;
  overflow: hidden;
}

/* Table Styling */
.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  
  ::v-deep thead th {
    background-color: #f8fafc !important;
    color: #475569 !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    padding: 14px 16px !important;
    border-bottom: 2px solid #edf2f7 !important;
    border-top: none !important;
  }
  
  ::v-deep tbody td {
    padding: 16px !important;
    vertical-align: middle !important;
    color: #334155 !important;
    font-size: 13px !important;
    border-bottom: 1px solid #edf2f7 !important;
  }
  
  ::v-deep tbody tr {
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(30, 149, 143, 0.02) !important;
    }
  }
}

/* Custom Badge Styles */
.badge-light-success {
  background-color: rgba(30, 149, 143, 0.08) !important;
  color: #1e958f !important;
}
.badge-light-warning {
  background-color: rgba(245, 158, 11, 0.08) !important;
  color: #d97706 !important;
}
.badge-light-primary {
  background-color: rgba(20, 96, 143, 0.08) !important;
  color: #14608f !important;
}
.badge-light-danger {
  background-color: rgba(239, 68, 68, 0.08) !important;
  color: #ef4444 !important;
}

/* Action Buttons */
.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px !important;
  padding: 0 !important;
  border: none !important;
  transition: all 0.2s ease;
  
  i {
    font-size: 12px !important;
  }
  
  &.btn-light-primary {
    background-color: rgba(20, 96, 143, 0.08) !important;
    
    i {
      color: #14608f !important;
    }
    
    &:hover {
      background-color: #14608f !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-success {
    background-color: rgba(30, 149, 143, 0.08) !important;
    
    i {
      color: #1e958f !important;
    }
    
    &:hover {
      background-color: #1e958f !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-info {
    background-color: rgba(56, 189, 248, 0.12) !important;
    
    i {
      color: #0284c7 !important;
    }
    
    &:hover {
      background-color: #0284c7 !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-danger {
    background-color: rgba(239, 68, 68, 0.08) !important;
    
    i {
      color: #ef4444 !important;
    }
    
    &:hover {
      background-color: #ef4444 !important;
      i {
        color: #fff !important;
      }
    }
  }
}
</style>